<template>
  <div class="image-grid">
    <div class="has-text-centered" v-if="isLoading">
      <button
        disabled="disabled"
        class="button is-loading is-disabled is-white"
      >
        ...
      </button>
    </div>
    <div class="images-list" v-else>
      <figure class="image-item" :class="ImageSize === '240x260' ? 'image is-128x128' : ''" v-for="(img, index) in images" :key="index">
        <pop-confirm
          content="Tem certeza?"
          cancel-text="Não"
          ok-text="Sim"
          :on-ok="() => $emit('remove', img.id)"
          class="remove-confirm"
          v-if="allowRemove"
        >
          <button class="button is-danger is-small button-remove">
            <i class="fa fa-remove"></i>
          </button>
        </pop-confirm>
        <a :href="img.urls['original']" class="download-original-link" target="_blank" download v-if="viewOriginal">
          <span>Baixar imagem original</span>
        </a>
        <img
          :alt="img.id"
          :src="img.urls ? img.urls[ImageSize] : null"
        />
        <small v-if="img.creator">
          <figure class="image is-24x24">
            <img :src="img.creator.avatarUrls ? img.creator.avatarUrls['150x150'] : 'https://i.imgur.com/FEtJtdg.png'" />
          </figure>
          {{img.creator.firstName}} {{img.creator.lastName}}
        </small>
      </figure>
      <p v-if="images.length === 0">{{emptyMensage}}</p>
    </div>
    <pagination
        v-if="Object.keys(paginationController).length > 0 && images.length > 0"
        :total="paginationController.total"
        :page-size="paginationController.limit"
        layout="pager"
        :change="(page) => $emit('change-page', page)"
      />
  </div>
</template>

<script>
export default {
  name: 'ImageGrid',
  props: {
    images: {
      type: Array,
      required: true
    },
    ImageSize: {
      type: String,
      required: true
    },
    isLoading: {
      type: Boolean,
      default: false
    },
    paginationController: {
      type: Object,
      default: () => ({})
    },
    emptyMensage: {
      type: String,
      default: 'Não existem imagens cadastradas'
    },
    allowRemove: {
      type: Boolean,
      default: false
    },
    viewOriginal: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    imageUrl (url) {
      if (url.includes('.jpg') || url.includes('.png')) {
        return url
      }
      return `${url}.jpg`
    }
  }
}
</script>

<style lang="scss">
  .image-grid {
    .download-original-link {
      position: absolute;
      top: 0;
      right: 0;
      left: 0;
      bottom: 0;
      text-align: center;
      display: block;
      span {
        color: #fff;
        font-size: 12px;
        display: inline-block;
        position: absolute;
        left: 0;
        right: 0;
        top: 50%;
        margin-top: -12px;
        display: none;
      }
      &:hover {
        background: rgba(0,0,0, 0.8) !important;
        border-bottom: none;
        span {
          display: inline-block;
        }
      }
    }
    .remove-confirm {
      position: absolute;
      top: 0;
      right: 0;
      z-index: 10;
    }
    .button-remove {
      width: 24px;
      height: 24px;
      border-radius: 100%;
    }
    .button.is-loading {
      height: 80px;
      &:after {
        width: 40px;
        height: 40px;
      }
    }
    .images-list {
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      .image-item {
        margin: 5px;
        width: 135px;
        text-align: center;
        img {
          max-width: 100%;
        }
        small {
          vertical-align: middle;
          margin-top: 5px;
          figure.image {
            vertical-align: middle;
            display: inline-block;
          }
        }
        &.is-128x128 {
          height: 157px;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/ImageGrid.vue